import { render, staticRenderFns } from "./CheckItemCard.vue?vue&type=template&id=332bd2e6&scoped=true&"
import script from "./CheckItemCard.vue?vue&type=script&lang=js&"
export * from "./CheckItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckItemCard.vue?vue&type=style&index=0&id=332bd2e6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bd2e6",
  null
  
)

export default component.exports